import React from "react";
import AIModuleSubtopic from "../AIModuleSubtopic";

const ElementaryTwoPlayerGames = () => (
  <AIModuleSubtopic
    title="Elementary two-players games: tic-tac-toe, Minimax with Alpha-Beta Pruning"
    videos={[
      "https://www.youtube.com/embed/9D1hVGumxCo",
      "https://www.youtube.com/embed/H0hRly9JanE"
    ]}
    takeaways={[
      { text: "Understand how Minimax and Alpha-Beta Pruning algorithms are applied to two-player games like tic-tac-toe." },
      { text: "Learn the process of pruning and its impact on search efficiency." }
    ]}
    questions={[
      {
        text: "Consider the following two-person game. Apply the alpha-beta algorithm to it and demonstrate the corresponding search tree built by this algorithm. Clearly show the pruned nodes or branches of the tree. Justify that the pruned nodes do not have any impact on the outcome of the game.",
        image:"/ai_26.png"
      },
      {
        text: "Consider the following 4-ply two-person Game. Apply the alpha-beta algorithm to it and demonstrate the corresponding search tree built by this algorithm. Clearly show the pruned nodes or branches of the tree. Justify that the pruned nodes do not have any impact on the outcome of the game.",
        image:"/ai_27.png"
      },
      {
        text: "Explain in detail about the Alpha Beta Pruning technique and solve the given problem using the same to find out all the unvisited nodes in the given tree",
        image:"/ai_28.png"
      },
      {
        text: "Write the pseudocode for alpha-beta pruning. Identify the nodes that are pruned using the alpha-beta pruning algorithm.",
        image:"/ai_29.png"
      },
      {
        text: "Write pseudo/code for Alpha-Beta Pruning. Apply both the minimax algorithm and Alpha Beta pruning for the following graph.",
        image:"/ai_30.png"
      },
      {
        text: "Consider the game tree given below in which the first player is the maximizing player. Applying mini-max search, show the backed-up values in the tree. If the nodes are expanded from left to right, what nodes would not be visited using alpha-beta pruning? Also, explain how pruning is done.",
        image:"/ai_31.png"
      },
      {
        text: "Consider the following two-person game. Apply the alpha-beta algorithm to it and demonstrate the corresponding search tree built by this algorithm. Clearly show the pruned nodes or branches of the tree. Justify that the pruned nodes do not have any impact on the outcome of the game.",
        image:"/ai_32.png"
      },
      {
        text: "Consider the following two-person game. Apply the alpha-beta algorithm to it and demonstrate the corresponding search tree built by this algorithm. Clearly show the pruned nodes or branches of the tree. Justify that the pruned nodes do not have any impact on the outcome of the game.",
        image:"/ai_33.png"
      },
      {
        text: "Find the minimax values of the nodes using the Mini-Max Algorithm. Prune the nodes that do not affect the game's outcome using the Alpha-Beta pruning algorithm.",
        image:"/ai_34.png"
      },
      {
        text: "Consider the game tree in which the static scores are from the first player's point of view. Suppose the first player is a maximizing player. Applying mini-max search, show the backed-up values in the tree. What move will the MAX choose? If the nodes are expanded from left to right, what nodes would not be visited using alpha-beta pruning? Also, explain the limitations of the Mini-Max search. How to overcome them?",
        image:"/ai_35.png"
      },
      {
        text: "Consider a complete binary tree with the leaf nodes 5, 4, 3, 2, 8, 9, 10, 11, 3, 12, 2, 13, 15, 10, 14, 17 (left to right). Consider that tree as the game tree. By Applying mini-max search, show the backed-up values in the tree. Assume min takes the first call. If the nodes are expanded from left to right, analyze the efficiency if alpha-beta pruning is applied?"
      },
      {
        text: "Consider a two-player turn-based strategy game where each player tries to maximize or minimize the game score at the end of the game. The game tree is given below: a) Apply the Minimax Algorithm to determine the optimal move for the Maximizer at the start node. Show all calculations for each node. b) Apply Alpha-Beta Pruning to the same game tree and show how it reduces the number of node evaluations. Explain which nodes were pruned and why.",
        image:"/ai_36.png"
      },
      {
        text: "You are designing an Al agent to play a real-time strategy game. Discuss the challenges of using Minimax with Alpha-Beta Pruning in this context and suggest potential solutions."
      }
    ]}
    exampleVideos={[]}
  />
);

export default ElementaryTwoPlayerGames;
